import { render, staticRenderFns } from "./studentTopPage.vue?vue&type=template&id=1894ff56&scoped=true&"
import script from "./studentTopPage.vue?vue&type=script&lang=js&"
export * from "./studentTopPage.vue?vue&type=script&lang=js&"
import style0 from "./studentTopPage.vue?vue&type=style&index=0&id=1894ff56&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1894ff56",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\桌面\\学习资料\\ZXX\\ZJPMWEB\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1894ff56')) {
      api.createRecord('1894ff56', component.options)
    } else {
      api.reload('1894ff56', component.options)
    }
    module.hot.accept("./studentTopPage.vue?vue&type=template&id=1894ff56&scoped=true&", function () {
      api.rerender('1894ff56', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/zxx/components/home-page/studentTopPage.vue"
export default component.exports